import ExternalLinksBaseHandler from '../external_links_base_handler';
import {MY_ACCOUNT_POST_ACTIONS}  from './external_links_my_account_handler_consts';
import _ from '../../../../utils/underscore';
import * as EXTERNAL_LINKS_CONSTS from '../../external_links_consts';
import ServiceFactory from '../../../../services/service_factory';
import {OMG_POST_ACTIONS} from "../omg/external_links_omg_handler_consts";
import Event from "../../../../utils/event";
import {SYSTEM_EVENTS} from "../../../../events/events";
import {NAVIGATION_VIEWS} from "../../external_links_consts";
import Device from "../../../../utils/device";
import {PRIORITY_LEVEL} from "../../../../services/overlay_manager/overlay_manager_levels";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../../../common/const/casinofied-analytics-consts";
import {isDepositSessionType, isCashoutSessionType} from "../../../../../../common/utils/cashier-util";
import {AreaType} from "@sparkware/uc-sdk-core/lib/apps/app-enums";


/**
 *
 */
class ExternalLinksMyAccountHandler extends ExternalLinksBaseHandler {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksMyAccountHandler';
    static HandlerName = 'my_account';

    /**
     * Overrides base class
     * @param postMessageData
     */
	executePostMessageAction(postMessageData) {
        let postDataObjLower = _.toLowerCaseKeys(postMessageData);
        switch (postDataObjLower.actionid.toString()) {
			case MY_ACCOUNT_POST_ACTIONS.EXTERNAL_URL:
				let navView = Device.isMobile() ? NAVIGATION_VIEWS.IFRAME : NAVIGATION_VIEWS.WINDOW;
				/* 'addCloseOption' param is drilled down into external link component for add close overlay option.)
					now it's disabled by css for mobile external link overlay */
				this.openExternalLink({sourceLink: postMessageData.url, addCloseOption: true, view: navView, priorityLevel: PRIORITY_LEVEL.INTERNAL_OVER_EXTERNAL_LINK});
				break;
            case MY_ACCOUNT_POST_ACTIONS.GAME:
                this.close();
                if (_.isUndefined(postDataObjLower.gameid) || _.isNull(postDataObjLower.gameid)) {
                    this.logger.warn('GameId is undefined or empty. Unable to open real game from MyAccount');
                    break;
                }
                this.openRealGame(postDataObjLower.gameid, postDataObjLower.origininformation.originDeepLinkID);
                break;
            case MY_ACCOUNT_POST_ACTIONS.RICH:
                this.close();
                let richPageUrl = ServiceFactory.create().integrationService().getRichPageUrl(postDataObjLower.campaignid);
                this._serviceFactory.windowService().redirect(richPageUrl);
                break;
            case MY_ACCOUNT_POST_ACTIONS.CASHIER:
                this._handleCashierOpening(postMessageData);
                this.close();
                break;
            case MY_ACCOUNT_POST_ACTIONS.QUICK_DEPOSIT:
                this._handleQuickDeposit(postMessageData);
                this.close();
                break;
			case OMG_POST_ACTIONS.SPORT:
				this.openExternalLink({
					source: EXTERNAL_LINKS_CONSTS.GNWP_SOURCES.SPORT
				});
				this.close();
				break;
            case MY_ACCOUNT_POST_ACTIONS.CASINO:
                //SpecificNavigation should be used only from OMG
                if (postDataObjLower.specificnavigation) {
                    //add logic here
                }
                //TODO maybe it is prefer to check if we are on the same web site, and do not redirect in this case
                this._serviceFactory.windowService().redirect(ServiceFactory.create().integrationService().getLobbyUrlLink());
                this.close();
                break;
            case MY_ACCOUNT_POST_ACTIONS.CLOSE:
                this.close();
                break;
            case MY_ACCOUNT_POST_ACTIONS.INTERNAL_URL:
			    this._openInternalLink(postMessageData);
			    break;
            default:
                this.logger.warn('Not supported ActionID. ActionID = ' + postDataObjLower.actionid);
                break;
        }
    }

    /**
     * Handle post message with ActionId = 6 - CASHIER
     * Based on tab id on this post message, we can open either deposit, either cashout
     * @param postMessageData
     * @private
     */
    _handleCashierOpening(postMessageData) {
        let channelElement = null;
        let sessionType = postMessageData.TabId;


        if (isDepositSessionType(sessionType)) {
            channelElement = CHANNEL_ELEMENTS.depositButton;
        } else if (isCashoutSessionType(sessionType)) {
            channelElement = CHANNEL_ELEMENTS.withdrawButton;
        }

        this.openCashier(postMessageData, {
            source: CHANNEL_SOURCE.myAccount,
            area: AreaType.Header,
            element: channelElement
        });
    }

    /**
     * Handle post message with ActionId = 7 - QUICK_DEPOSIT
     * @param postMessageData
     * @private
     */
    _handleQuickDeposit(postMessageData) {
        let options = {};
        if (postMessageData.PromCode) {
            //update promo code to open cashier with one received from My Account
            options.PromCode = postMessageData.PromCode;
        }

        this._serviceFactory.cashierProxyService().openDeposit({
            ...options,
            channel: {
                source: CHANNEL_SOURCE.myAccount,
                area: AreaType.Header,
                element: CHANNEL_ELEMENTS.depositButton
            }
        });

        this.close();

    }


    getHandlerName() {
        return ExternalLinksMyAccountHandler.HandlerName;
    }


	/**
	 * Open Internal Link url over the same page
	 * @private
	 */
	_openInternalLink(postData) {
		if (postData && postData.Url) {
			//verify if it's internal url
			if (this._serviceFactory.windowService().getDomain() ===  this._serviceFactory.windowService().extractDomain(postData.Url)) {
                 this._serviceFactory.windowService().redirect(postData.Url);
			} else {
				this.logger.error('Redirect to internal url ' + postData.Url + ' has been prevented. ' + postData.Url + ' is not an internal url of ' +  this._serviceFactory.windowService().getDomain());
				Event.fire(SYSTEM_EVENTS.INTERNAL_URL_NAVIGATION, {url: postData.Url});
			}
		}
	}
}

export default ExternalLinksMyAccountHandler;